<ng-template #templateSelectedResources let-item="item">
    <span [attr.class]="item?.resourceType == 'host' ? 'badge badge-blue' : (item?.resourceType == 'vm' ? 'badge badge-light-blue': 'badge badge-orange')">{{ item?.resourceType }}</span>
    {{ item?.name }}
</ng-template>

<ng-template #templateDisplayResources let-item='item'>
    <span class="badge" [attr.class]="item?.resourceType == 'host' ? 'badge badge-blue' : (item?.resourceType == 'vm' ? 'badge badge-light-blue': 'badge badge-orange')">{{ item?.resourceType }}</span>
    {{ item?.name }}
</ng-template>

<ng-template #templateDisplayResourcesWhenEmpty>
    <clr-control-helper slot="displayWhenEmpty">Type a resource name</clr-control-helper>
</ng-template>

<ng-template #templateDisplayResourcesWhenErrors>
    <clr-control-error slot="displayWhenError">There was an error</clr-control-error>
</ng-template>

<div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; display: flex; flex-flow: column;">

    <clr-alert [clrAlertType]="'danger'" [clrAlertAppLevel]="true" *ngIf="failureMode && !isLoading">
        <clr-alert-item>
            <span class="alert-text">Cannot load data from DC Netscope API. Please check the diagnostic page.</span>
            <div class="alert-actions">
                <a routerLink="/diagnostic" routerLinkActive="active">
                    <button class="btn alert-action">
                        <cds-icon shape="checkbox-list"></cds-icon>
                        Diagnostic
                    </button>
                </a>
            </div>
        </clr-alert-item>
    </clr-alert>

    <div style="padding-left: 30px; padding-right: 30px;">

        <div class="clr-row">
            <div class="clr-col-md clr-col-lg clr-col-12">
                <div class="card">
                    <div class="card-block">
                        <div class="card-title">
                    <span class="badge badge-blue">
                      step 1
                    </span>
                            Pick a first resource
                        </div>
                        <div class="card-text">
                            <app-heatmap-combobox
                                    [(selectedItems)]="selectedResources1"
                                    [itemsGenerator]="fetchVms1"
                                    (onChange)="vm1SelectionChanged()"
                                    [templateSelectedItems]="templateSelectedResources"
                                    [templateDisplayItems]="templateDisplayResources"
                                    [templateDisplayWhenEmpty]="templateDisplayResourcesWhenEmpty"
                                    [templateDisplayWhenErrors]="templateDisplayResourcesWhenErrors"
                                    [itemsField]="'name'"
                                    [disabled]="combobox1IsDisabled"
                                    #vm1Combobox
                            >
                            </app-heatmap-combobox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clr-col-lg-2 clr-col-md-2 clr-col-12">
                <div class="card">
                    <div class="card-block" style="padding-right: 15px; padding-left: 15px;">
                        <div class="card-title">
                    <span class="badge badge-blue">
                      step 2
                    </span>
                            Select direction
                        </div>
                        <div class="card-text" style="margin: auto;">
                            <clr-radio-wrapper>
                                <input type="radio" [(ngModel)]="directionMode" clrRadio value="unidirectional" name="options" (change)="directionChanged()"/>
                                <label><cds-icon shape="arrow" direction="right"></cds-icon> Single way</label>
                            </clr-radio-wrapper>
                            <clr-radio-wrapper>
                                <input type="radio" [(ngModel)]="directionMode" clrRadio value="bidirectional" name="options" (change)="directionChanged()" />
                                <label><cds-icon shape="two-way-arrows"></cds-icon> Two ways</label>
                            </clr-radio-wrapper>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clr-col-md clr-col-lg clr-col-12">
                <div class="card">
                    <div class="card-block">
                        <div class="card-title">
                    <span class="badge badge-blue">
                      step 3
                    </span>
                            Pick a second resource
                            <span class="spinner spinner spinner-inline spinner-inverse" *ngIf="combobox2IsLoading">Loading...</span>
                        </div>
                        <div class="card-text">
                            <app-heatmap-combobox
                                    [(selectedItems)]="selectedResources2"
                                    [itemsGenerator]="fetchVms2"
                                    (onChange)="vm2SelectionChanged()"
                                    [templateSelectedItems]="templateSelectedResources"
                                    [templateDisplayItems]="templateDisplayResources"
                                    [templateDisplayWhenEmpty]="templateDisplayResourcesWhenEmpty"
                                    [templateDisplayWhenErrors]="templateDisplayResourcesWhenErrors"
                                    [itemsField]="'name'"
                                    [disabled]="combobox2IsDisabled"
                                    #vm2Combobox
                            >
                            </app-heatmap-combobox>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="clr-row" *ngIf="selectedResources1?.length > 0" style="margin-bottom: 25px;">
            <div class="clr-col-12">
                <div class="card">
                    <div class="card-header">
                        Traffic between <span class="label">{{ selectedResources1[0]?.name }}</span>
                        @if (selectedResources2.length > 0) {
                          and <span class="label">{{ selectedResources2[0]?.name }}</span>
                        } @else {
                          and the rest of the infrastructure
                        }
                        <span class="spinner spinner spinner-inline spinner-inverse" *ngIf="heatmapIsLoading">Loading...</span>

                        <clr-radio-container clrInline style="position: relative; top: -5px; margin: 0; float: right;">
                          <label>Heatmap detail level</label>
                          <clr-radio-wrapper>
                            <input type="radio" clrRadio name="timeResolution" required value="daily" [(ngModel)]="timeResolutionRadioButtonValue" (change)="heatmapDetailLevelChanged()"/>
                            <label>Daily</label>
                          </clr-radio-wrapper>
                          <clr-radio-wrapper>
                            <input type="radio" clrRadio name="timeResolution" required value="hourly" [(ngModel)]="timeResolutionRadioButtonValue" (change)="heatmapDetailLevelChanged()"/>
                            <label>Hourly</label>
                          </clr-radio-wrapper>
                        </clr-radio-container>

                    </div>
                    <div class="card-block">
                        <div class="card-title">
                        </div>
                        <div class="card-text">
                            <app-heatmap-highcharts-heatmap
                                    [onClick]=""
                                    [updateEmitter]="resourceSelectionChanged"
                                    [clickOnTimeSlotEmitter]="clickOnTimeSlotEmitter"
                                    [loadingStateEmitter]="loadingStateUpdateEmitter"
                                    [selectedResources1]="selectedResources1"
                                    [selectedResources2]="selectedResources2"
                                    [directionMode]="directionMode"
                                    [doubleClickSelectDay]="true"
                                    [temporalResolution]="timeResolutionRadioButtonValue"
                                    #temporalSelectionHeatMap
                            ></app-heatmap-highcharts-heatmap>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<clr-side-panel id="flowsSidePanel" [clrSidePanelSize]="'lg'" [(clrSidePanelOpen)]="sidePanelOpened" [clrSidePanelStaticBackdrop]="false" [clrFocusOnViewInit]="true" #flowsSidePanel>
  <h3 class="side-panel-title" style="width: 100%;">
    {{ sidePanelTitle }}
    @if (sidePanelResourceUuid !== undefined) {
<!--      @if (sidePanelIsAlreadyFocused) {-->
<!--        <button class="btn btn-sm btn-primary" (click)="switchFocus({id: sidePanelResourceUuid})">unfocus</button>-->
<!--      } @else {-->
<!--        <button class="btn btn-sm btn-primary" (click)="switchFocus({id: sidePanelResourceUuid})">focus</button>-->
<!--      }-->
    }
  </h3>
  <div class="side-panel-body">
    <div class="clr-row">
      <div class="clr-col">
        <div echarts id="heatmap-side-panel-protocols-chart" [options]="sidePanelProtocolsOptions" class="demo-chart" style="height: 300px;"></div>
      </div>
      <div class="clr-col">
        <div echarts id="heatmap-side-panel-origins-chart" [options]="sidePanelOriginsOptions" class="demo-chart" style="height: 300px;"></div>
      </div>
    </div>
    <div class="clr-row">
      <div class="clr-col">
        <app-netscope-flows-datagrid
          [mergeSourceAndTarget]="true"
          [temporalParameter]="temporalParameter"
          [flowDetails]="sidePanelFlows" [ignoreFilters]="true"
          [showHosts]="false" [hidePacketsExchanged]="true"
          [perPortRow]="true"
          [showPortInline]="true"
          [switchFocus]="switchFocus"
          [exportCsvEnabled]="true"
          [callExportCsv]="exportRowPerPortCSV">
        </app-netscope-flows-datagrid>
      </div>
    </div>
  </div>
  <div class="side-panel-footer">
<!--    <button type="button" class="btn btn-outline" (click)="sidePanelOpened = false">Cancel</button>-->
    <button type="button" class="btn btn-primary" (click)="sidePanelOpened = false">Close</button>
  </div>
</clr-side-panel>

